<template>
  <CenteredForm :width="478" :vertical="false">
    <div class="form-wrapper">
      <p class="title">Create a new project</p>
      <form>
        <div class="inputs">
          <div class="" style="width: 100%" id="field-name">
            <ts-form-item label="Project name" :validation="$v.name">
              <div class="flex project-name" style="color: #6d7587">
                <div class="date">{{ projectDate }}</div>
                <div class="project-brand" style="flex: none">{{ projectBrand }}</div>
                <ts-input v-model.lazy="$v.name.$model" :disabled="loading"></ts-input>
              </div>
            </ts-form-item>
            <div class="errors-item" v-show="hasError('name')">
              <p class="">
                This project name already exists
                <!-- {{ this.getError('name') }} -->
              </p>
            </div>
          </div>
          <ts-form-item label="Brand name" :validation="$v.brands" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a brand"
                text-filter
                show-picture
                size="large"
                :max-items="2"
                :width="378"
                :options="filteredBrands"
                v-model.lazy="$v.brands.$model"
                @selected="onBrandsSelected"
                @reset="onBrandsReset"
                @saved="onBrandsSaved"
            >
              <template v-slot:header="{ selectOptionHandler, selectable }">
                <form action="" @submit.prevent="createBrand(selectOptionHandler)" class="brand-form" v-if="selectable">
                  <input
                    type="text"
                    class=""
                    placeholder="Add a brand : type the new brand name here"
                    v-model="brandInput"
                  />
                </form>
              </template>
            </MultiSelectionDropdown>
          </ts-form-item>
          <div style="margin: 10px 0 20px 0;font-family: Roboto;font-size: 15px;color: #6d7587;">If you can't find the brand, send an email to : <a href="mailto:access@thesource.social">access@thesource.social</a> and brand will be created within a few hours</div>
          <ts-form-item label="Project type" :validation="$v.projectType" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a project type"
                :max-items="1"
                text-filter
                :width="378"
                size="large"
                :options="projectTypes"
                :read-only-single-option="false"
                v-model.lazy="$v.projectType.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Partner" :validation="$v.partner" class="dropdown" v-if="shouldSelectPartner">
            <MultiSelectionDropdown
                placeholder="Select a partner"
                :max-items="1"
                text-filter
                :width="378"
                size="large"
                :options="partners"
                :read-only-single-option="false"
                v-model.lazy="$v.partner.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Program" :validation="$v.program" class="dropdown" v-if="shouldSelectProgram">
            <MultiSelectionDropdown
                placeholder="Select a program"
                :max-items="1"
                :width="378"
                text-filter
                size="large"
                :options="programs"
                :read-only-single-option="false"
                v-model.lazy="$v.program.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <!-- <ts-form-item label="Parent project (optional)" :validation="$v.parentProjects" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Select a project"
              text-filter
              size="large"
              :max-items="1"
              :width="378"
              :options="projectOptions"
              :read-only-single-option="false"
              v-model.lazy="$v.parentProjects.$model"
            ></MultiSelectionDropdown>
          </ts-form-item> -->
          <!-- <ts-form-item label="Destination platform (optional)" :validation="$v.platform" class="dropdown">
           <MultiSelectionDropdown
               placeholder="Select a destination platform"
               :width="378"
               size="large"
               :options="platforms"
               :read-only-single-option="false"
               v-model.lazy="$v.platform.$model"
           >
           </MultiSelectionDropdown>
         </ts-form-item> -->
          <ts-form-item label="Production type" :validation="$v.productionType" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a production type"
                :max-items="1"
                text-filter
                :width="378"
                size="large"
                :options="filteredProductionTypes"
                :read-only-single-option="false"
                v-model.lazy="$v.productionType.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Group" :validation="$v.groupSelected" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Enter the group name"
              text-filter
              :max-items="1"
              style="margin-top: 10px;"
              :width="378"
              size="large"
              :options="filteredGroups"
              :read-only-single-option="false"
              v-model.lazy="$v.groupSelected.$model"
              class="project-status-select"
              @selected="onGroupSelected"
              @reset="onGroupReset"
              @saved="onGroupSaved"
            >
              <template v-slot:header="{ selectOptionHandler, selectable }">
                <form action="" @submit.prevent="createGroup(selectOptionHandler)" class="brand-form"
                      v-if="selectable">
                  <input
                    type="text"
                    class=""
                    placeholder="Add a group : type the new group name here"
                    v-model="groupInput"
                  />
                </form>
              </template>
            </MultiSelectionDropdown>
          </ts-form-item>

          <ts-form-item label="Industry" :validation="$v.industry" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select industry"
                text-filter
                :max-items="1"
                :width="378"
                size="large"
                :options="industryTypes"
                :read-only-single-option="false"
                v-model.lazy="$v.industry.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Country" :validation="$v.country" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a country"
                text-filter
                :max-items="1"
                :width="378"
                size="large"
                :options="regions"
                :read-only-single-option="false"
                v-model.lazy="$v.country.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Status" :validation="$v.status" class="dropdown" style="display: none">
            <ProjectStatusSelect
                size="large"
                :width="378"
                :statuses="statusOptions"
                v-model.lazy="$v.status.$model"
                class="project-status-select"
            />
          </ts-form-item>
          <ts-form-item label="Folder" :validation="$v.folder">
            <MultiSelectionDropdown
                placeholder="Please select a folder"
                :max-items="1"
                :textFilter="true"
                :width="378"
                size="large"
                :options="folders"
                :read-only-single-option="false"
                v-model.lazy="foldersSelected"
            >
              <template v-slot:header>
                <form action="" @submit.prevent="handleCreateFolderClick" class="folder-form">
                  <button
                      type="submit"
                  >
                    Click here to create a new folder
                  </button>
                </form>
              </template>
            </MultiSelectionDropdown>
          </ts-form-item>
          <div class="actions">
            <ts-button :loading="loading" @click="handleSubmit">Create the project</ts-button>
          </div>
        </div>
      </form>
    </div>
    <create-folder/>
  </CenteredForm>
</template>

<style lang="scss" scoped>
.brand-form {
  width: 100%;

  input {
    &::placeholder {
      color: #39c88c !important;
    }

    &:-moz-placeholder {
      color: #39c88c !important;
    }

    &:-webkit-input-placeholder {
      color: #39c88c !important;
    }

    color: #39c88c;
    width: 100%;
    padding: 5px 10px;
    // color: #6d7587;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);

    &:focus {
      outline: 0;
    }
  }
}

.folder-form {
  width: 100%;

  button {
    background: #3fb78f75;

    &::placeholder {
      color: black !important;
      // color: #39c88c !important;
    }

    &:-moz-placeholder {
      color: black !important;
      // color: #39c88c !important;
    }

    &:-webkit-input-placeholder {
      color: black !important;
      // color: #39c88c !important;
    }

    color: rgb(73, 73, 73);
    font-family: Roboto;
    // color: #39c88c;
    width: 100%;
    padding: 5px 10px;
    // color: #6d7587;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);

    &:focus {
      outline: 0;
    }
  }
}

.project-name {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .date {
    padding-left: 0.2rem;

    &::after {
      content: '-';
      margin-left: 5px;
    }
  }

  .project-brand {
    padding: 0.2rem;

    &::after {
      content: '-';
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}

.errors-item {
  font-size: 0.85rem;
  margin-top: -10px;
  color: red;
}

.input-folder::placeholder {
  color: #39c88c !important;
}

.input-folder:-moz-placeholder {
  color: #39c88c !important;
}

.input-folder:-webkit-input-placeholder {
  color: #39c88c !important;
}

.input-folder {
  flex: 1;
  height: 100%;
  padding: 0 10px;
  color: #39c88c;
}

.input-folder:focus {
  outline: 0;
}

.create-folder {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 0;
  box-shadow: 5px 5px 10px 0 rgba(166, 171, 189, 0.48), -5px -5px 10px 0 rgba(250, 251, 255, 0.8);
  border: solid 2px rgba(255, 255, 255, 0.16);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(278deg, #000000 100%, var(--fills-neutral-white) 0%),
  linear-gradient(to bottom, #ebecf0, #ebecf0);
}

.form-wrapper {
  margin: 80px 0;
}

.icon {
  text-align: center;
  margin-bottom: 12px;
}

.title {
  font-family: Roboto;
  font-size: 20px;
  color: #6d7587;
  text-align: center;
  margin-bottom: 28px;
}

.message {
  font-family: Roboto;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: #6d7587;
}

.inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dropdown {
  margin: 10px 0;
}

.project-status-select {
  margin: 10px 0;
}

.actions {
  margin-top: 20px;
}
</style>

<script>
import {mapState, mapActions} from 'vuex';
import {required, requiredIf} from 'vuelidate/lib/validators';

import {createProject} from '@/api/workflow';
import CreateFolder from './Folders/CreateFolder.vue';
import CenteredForm from '@/components/layouts/CenteredForm.vue';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
import DatePickerDropdown from '@/components/inputs/DatePickerDropdown.vue';
import ProjectStatusSelect from '@/components/inputs/ProjectStatusSelect.vue';
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import CustomMultiSelectionDropdown from '@/components/inputs/CustomMultiSelectionDropdown.vue';

export default {
  components: {
    CustomMultiSelectionDropdown,
    CenteredForm,
    MultiSelectionDropdown,
    DatePickerDropdown,
    ProjectStatusSelect,
    CreateFolder,
    CustomSelect
  },
  data() {
    return {
      loading: false,
      errors: {},
      name: '',
      parentProjects: [],
      parentFolder: null,
      newFolder: null,
      brandInput: null,
      newBrands: [],
      brands: [],
      groupInput: null,
      newGroups :[],
      dueDate: null,
      folder: null,
      foldersSelected: [],
      countrySelected: [],
      industrySelected: [],
      groupSelected: [],
      status: 'delivered',
      projectType: [],
      productionType: [],
      partner: [],
      program: [],
      platform: [],
      industry: [],
      country: []
    };
  },
  watch: {
    projectType(value) {
      if (value[0] != 'partner') {
        this.partner = [];
      }
    },
    partner(value) {
      if (!['facebook', 'tf1'].includes(value[0])) {
        this.program = [];
      }
    }
  },
  computed: {
    ...mapState('workflow', {
      statusOptions: state => state.statuses.items,
      brandOptions: state => state.brandsManual.items,
      productionTypes: state => state.myProjects.options.productionTypes,
      projectTypes: state => state.myProjects.options.projectTypes,
      partners: state => state.myProjects.options.partners,
      programs: state => state.myProjects.options.programs,
      groups: state => state.myProjects.options.groups,
      platforms: state => state.myProjects.options.platforms,
      folders: state => state.myProjects.items,
      industryTypes: state => state.industryTypes.items.map(b => ({...b, _id: b.id, id: b.slug})),
      regions: state => state.regions.items.map(b => ({...b, _id: b.id, id: b.slug})),
    }),
    filteredGroups() {
      return [].concat(this.newGroups, this.groups);
    },
    filteredBrands() {
      return [].concat(this.newBrands, this.brandOptions);
    },
    filteredProductionTypes() {
      return this.productionTypes.filter(b => ['optimized', 'original'].includes((b.name || '').trim().toLowerCase()));
    },
    shouldSelectPartner() {
      return this.projectType[0] == 'partner';
    },
    shouldSelectProgram() {
      return ['facebook', 'tf1'].includes(this.partner[0]);
    },
    projectOptions() {
      return this.folders.reduce((acc, value) => [].concat(acc, value.projects), []);
    },
    projectDate() {
      const date = new Date();
      return ('' + date.getUTCFullYear()).slice(-2) + '' + ('0' + (date.getMonth() + 1)).slice(-2);
    },
    projectBrand() {
      const brands = this.brandOptions.filter(b => this.brands.includes(b.id));
      return brands.length == 0 ? 'Brand' : brands.map(b => b.name).join(' X ');
    }
  },
  validations: {
    name: {
      required
    },
    folder: {
      required
    },
    parentProjects: {},
    brands: {
      required
    },
    dueDate: {},
    projectType: {
      required
    },
    productionType: {
      required
    },
    program: {
      required: requiredIf(vm => ['facebook', 'tf1'].includes(vm.partner[0]))
    },
    platform: {},
    partner: {
      required: requiredIf(vm => vm.projectType[0] == 'partner')
    },
    status: {
      required
    },
    country: {
      required
    },
    groupSelected: {},
    industry: {
      required
    }
  },
  methods: {
    ...mapActions('workflow', ['fetchBrandsManual', 'fetchMyProjects', 'fetchProjectOptions', 'fetchRegions', 'fetchIndustryTypes']),
    handleCreateFolderClick() {
      window.EventBus.$emit('folders.create', (folder) => {
        if (!folder) {
          return;
        }

        this.foldersSelected = [folder.id];

        if (folder.industry) this.industry = [folder.industry];
        if (folder.country) this.country = [folder.country];

      });
    },
    handleSubmit() {
      this.serverError = 0;
      if (this.foldersSelected.length > 0) {
        this.folder = this.foldersSelected[0];
      } else {
        this.folder = this.newFolder;
      }

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        createProject({
          name: this.name,
          folder: {name: this.newFolder},
          parentProjectId: this.parentProjects[0],
          brandIds: this.brands.filter(b => b > 0),
          newBrands: this.newBrands,
          newGroups: this.newGroups,
          folderId: this.foldersSelected.length > 0 ? this.folder : null,
          dueDate: this.dueDate || undefined,
          status: this.status,
          projectType: this.projectType[0],
          country: this.country[0],
          group: this.groupSelected ? this.groupSelected[0] : null,
          industry: this.industry[0],
          productionType: this.productionType[0],
          partner: this.partner[0],
          program: this.program[0],
          platforms: this.platform
        })
            .then(project => {
              this.loading = false;
              if (this.newBrands.length > 0) {
                this.newBrands = [];
                this.fetchBrandsManual();
              }
              this.$router.push({
                name: 'project-delivery',
                params: {
                  projectId: project.id
                }
              });
            })
            .catch(err => {
              if ('data' in err.response) {
                this.notifyErrors(err.response.data?.errors);
              }
              // console.error('Server error when creating project', err);
              this.loading = false;
            });
      } else {
        this.$nextTick(() => {
          const errorMessage = document.querySelector('.error-message');
          errorMessage && errorMessage.parentNode.scrollIntoView({behavior: 'smooth'});
        });
      }
    },
    onBrandsSelected() {
    },
    onBrandsReset() {
    },
    onBrandsSaved({items}) {
      if (this.brandInput) {
        this.createBrand(id => {
          this.brands.push(id);
        });
      }

      this.newBrands = this.newBrands.filter(b => {
        return this.brands.includes(b.id);
      });
    },
    onGroupSelected() {
    },
    onGroupReset() {
    },
    onGroupSaved({items}) {
      if (this.groupInput) {
        this.createGroup(id => {
          this.groups.push(id);
        });
      }

      this.newGroups = this.newGroups.filter(b => {
        return this.groups.includes(b.id);
      });
    },
    createBrand(selectionHandler) {
      const latest = this.newBrands.sort((a, b) => a.id - b.id)[0];

      const brand = {
        id: latest ? latest.id - 1 : 0,
        name: this.brandInput
      };

      this.brandInput = null;
      this.newBrands.push(brand);
      selectionHandler(brand.id, true);
    },
    notifyErrors(errors) {
      if (!errors) return;
      if ('name' in errors) {
        this.errors.name = errors.name;
        document.querySelector('#field-name').scrollIntoView({behavior: 'smooth'});
      }
    },
    hasError(key) {
      return key in this.errors && this.errors[key];
    },
    getError(key) {
      return this.hasError(key) ? this.errors[key][0] : null;
    },
    createGroup(selectionHandler) {
      const latest = this.newGroups.sort((a, b) => a.id - b.id)[0];

      const group = {
        id: latest ? latest.id - 1 : 0,
        name: this.groupInput
      };

      this.groupInput = null;
      this.newGroups.push(group);
      selectionHandler(group.id, true);
    }
  },
  mounted() {
    this.parentFolder = this.$route.params.folder ? this.$route.params.folder : null;
    this.fetchBrandsManual();
    this.fetchMyProjects();
    this.fetchProjectOptions();
    this.fetchIndustryTypes();
    this.fetchRegions();

    if (!this.parentFolder) return;
    this.foldersSelected = [this.parentFolder.id];
    this.partner = [this.parentFolder.partner];
    this.brands = this.parentFolder.brands.map(b => b.id);
    if (this.parentFolder.groups && this.parentFolder.groups.length > 0) {
      this.groupSelected = this.parentFolder.groups.map(g => g.id);
    }
    this.projectType = this.parentFolder.projectType != 'other' ? [this.parentFolder.projectType] : [];
    if (this.parentFolder.industry) this.industry = [this.parentFolder.industry];
    if (this.parentFolder.country) this.country = [this.parentFolder.country];
  }
};
</script>
